import React from 'react'
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Controller, useFieldArray } from 'react-hook-form'
import { useMapFormContext } from './FormContext'

const Contracts = () => {
  const {
    control,
    formState: { errors },
  } = useMapFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'contracts',
  })

  return (
    <>
      <Grid item xs={12}>
        <Typography variant='h6' fontWeight={600}>
          Contracts
        </Typography>
      </Grid>
      {fields.map((_, index) => (
        <Grid item xs={12} key={index}>
          <Accordion disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant='subtitle1' fontWeight={600}>
                {`Contract #${index + 1}`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Controller
                    name={`contracts.${index}.fundAmount`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        value={field.value ?? ''}
                        label='Fund Amount'
                        variant='outlined'
                        fullWidth
                        type='number'
                        error={!!error}
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name={`contracts.${index}.target`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        value={field.value ?? ''}
                        label='Target'
                        variant='outlined'
                        fullWidth
                        type='number'
                        error={!!error}
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name={`contracts.${index}.contractStartDate`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        value={field.value ?? ''}
                        label='Contract Start Date'
                        variant='outlined'
                        fullWidth
                        type='date'
                        InputLabelProps={{ shrink: true }}
                        error={!!error}
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name={`contracts.${index}.contractEndDate`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        value={field.value ?? ''}
                        label='Contract End Date'
                        variant='outlined'
                        fullWidth
                        type='date'
                        InputLabelProps={{ shrink: true }}
                        error={!!error}
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name={`contracts.${index}.notes`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        value={field.value ?? ''}
                        label='Notes'
                        variant='outlined'
                        fullWidth
                        multiline
                        minRows={3}
                        error={!!error}
                        helperText={error?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                  <Button
                    variant='outlined'
                    color='error'
                    disabled={fields.length === 1}
                    onClick={() => remove(index)}
                  >
                    Remove Contract
                  </Button>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Button variant='outlined' onClick={() => append({})}>
          Add Contract
        </Button>
      </Grid>
      {errors?.contracts?.message && (
        <Grid item xs={12}>
          <Typography variant='body2' color='error'>
            {errors.contracts.message}
          </Typography>
        </Grid>
      )}
      {errors?.contracts?.root && (
        <Grid item xs={12}>
          <Typography variant='body2' color='error'>
            {errors.contracts.root}
          </Typography>
        </Grid>
      )}
    </>
  )
}

export default Contracts
